module.exports = flarum.core.compat['Application'];